<template>
  <section class="advanced-tech-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="tech-content">
            <h2 class="tech-title">{{ headerData.title }}</h2>
            <p class="tech-description">{{ headerData.description }}</p>
            <div class="tech-features-list">
              <div class="tech-feature" v-for="(feature, index) in techFeatures" :key="index">
                <div class="feature-icon">
                  <i :class="feature.icon"></i>
                </div>
                <div class="feature-text">
                  <h4>{{ feature.title }}</h4>
                  <p>{{ feature.description }}</p>
                </div>
              </div>
            </div>
            <button class="tech-btn">{{ buttonText }}</button>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="tech-visual">
            <div class="tech-image-container">
              <img :src="techImage" :alt="headerData.title" class="tech-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsAdvancedTechComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        title: "Advanced Diagnostic Technology",
        description: "Our state-of-the-art diagnostic equipment and cutting-edge technology ensure accurate problem identification and efficient repairs."
      })
    },
    techFeatures: {
      type: Array,
      required: true,
      default: () => []
    },
    techImage: {
      type: String,
      required: true,
      default: "/images/resource/about-us.png"
    },
    buttonText: {
      type: String,
      required: false,
      default: "Explore Technology"
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Advanced Technology Section */
.advanced-tech-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.tech-content {
  padding-right: 40px;
}

.tech-title {
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.tech-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 40px;
  line-height: 1.6;
}

.tech-features-list {
  margin-bottom: 40px;
}

.tech-feature {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 24px;
  color: white;
}

.feature-text h4 {
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.feature-text p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.tech-btn {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  padding: 15px 35px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.tech-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(220, 53, 69, 0.3);
}

.tech-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.tech-image-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 350px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.tech-image-container:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
}

.tech-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.tech-image-container:hover .tech-image {
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 991px) {
  .tech-content {
    padding-right: 0;
    margin-bottom: 50px;
  }
  
  .tech-visual {
    height: 300px;
  }
  
  .tech-image-container {
    height: 250px;
  }
}

@media (max-width: 768px) {
  .tech-title {
    font-size: 32px;
  }
  
  .tech-description {
    font-size: 16px;
  }
  
  .tech-visual {
    height: 250px;
  }
  
  .tech-image-container {
    height: 200px;
  }
}
</style>
